import { AssignedTasks } from './tasks-assigned';
import { DocsAndLetters } from './docsAndLetters';
import * as dm from '../../../../../data-models';
import { IGeneratedCase } from '../..';
import { useState } from 'react';
import { OpenSectionState, TabCards } from '../tab-cards';
import './index.css';

type Props = {
  EETasks: dm.Task[];
  claim: IGeneratedCase;
  NTNId: string;
};

export const OverviewTab = ({ EETasks, claim, NTNId }: Props) => {
  const [openSection, setOpenSection] = useState<OpenSectionState>([
    'tasks',
    'docsAndLetters',
  ]);
  const [documentCount, setDocumentCount] = useState<number | null>(null);
  const [letterCount, setLetterCount] = useState<number | null>(null);

  const headerLinks = [
    {
      name: 'View all',
      link: '/app/tasks/' + NTNId,
    },
    {
      name: 'View all',
      link: '/app/documents/' + NTNId,
    },
  ];

  const combinedCount =
    [documentCount, letterCount]
      .filter((count): count is number => count !== null && count > 0)
      .reduce((total, count) => total + count, 0) || null;

  const sectionMapping = {
    tasks: {
      title: 'Assigned Tasks ' + (EETasks?.length ? `(${EETasks.length})` : ''),
      headerLinkName: headerLinks[0].name,
      headerLink: headerLinks[0].link,
      component: (
        <AssignedTasks
          EETasks={EETasks}
          headerLinkName={headerLinks[0].name}
          headerLink={headerLinks[0].link}
        />
      ),
      popupContent:
        'Tasks highlight information needed by Unum to assist in the management of your case. Please complete your required tasks by the due date provided or as soon as possible. Recommended tasks are optional.',
    },
    docsAndLetters: {
      title:
        'Documents & Letters ' +
        (combinedCount !== null && combinedCount > 0
          ? `(${combinedCount})`
          : ''),
      headerLinkName: headerLinks[1].name,
      headerLink: headerLinks[1].link,
      component: (
        <DocsAndLetters
          claim={claim}
          headerLink={headerLinks[1].link}
          documentCount={documentCount}
          letterCount={letterCount}
          setDocumentCount={setDocumentCount}
          setLetterCount={setLetterCount}
        />
      ),
      popupContent:
        'Documents and letters submitted by you or on your behalf that Unum has received for your case.',
    },
  };

  return (
    <TabCards
      sectionMapping={sectionMapping}
      openSection={openSection}
      setOpenSection={setOpenSection}
      ntn={NTNId}
    />
  );
};
